export default "__VITE_ASSET__BZTNzeOy__"